<template>
  <VModal ref="modal" @modal:hidden="$emit('closed')" disable-backdrop-click>
    <template #default>
      <div class="rounded-lg shadow-lg mx-auto bg-white w-full max-w-lg" @click.stop>
        <div class="p-4 flex justify-between bg-gray-200 rounded-t-lg">
          <nav class="flex">
            <button
              class="relative text-sm h-10 px-4 rounded-l focus:outline-none disabled:bg-transparent disabled:text-gray-600"
              :disabled="active"
              :class="[
                current === 'CreateMediaAsset'
                  ? 'bg-blue-600 text-white'
                  : 'bg-white text-gray-700',
              ]"
              @click="current = 'CreateMediaAsset'"
            >
              Local File
            </button>
            <button
              class="relative text-sm h-10 px-4 focus:outline-none disabled:bg-transparent disabled:text-gray-600"
              :disabled="active"
              :class="[
                current === 'CreateLinkAsset' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700',
              ]"
              @click="current = 'CreateLinkAsset'"
            >
              Link
            </button>
            <button
              class="relative text-sm h-10 px-4 rounded-r focus:outline-none disabled:bg-transparent disabled:text-gray-600"
              :disabled="active"
              :class="[
                current === 'CreateNoteAsset' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700',
              ]"
              @click="current = 'CreateNoteAsset'"
            >
              Note
            </button>
          </nav>
          <button
            ghost
            class="w-10 h-10 hover:bg-gray-200 rounded inline-flex items-center justify-center focus:outline-none focus:bg-blue-600 focus:text-white disabled:bg-transparent disabled:text-gray-600"
            :disabled="active"
            @click="$refs.modal.close()"
          >
            <svg
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
              class="w-5 h-5 inline-flex"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="p-4">
          <component
            :is="current"
            :project-id="projectId"
            :on-media-asset-created="handleAssetCreated"
            :on-link-asset-created="handleAssetCreated"
            :on-note-asset-created="handleAssetCreated"
            :on-active="handleActive"
          />
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import CreateMediaAsset from '@/components/ProjectAssets/CreateMediaAsset.vue';
import CreateLinkAsset from '@/components/ProjectAssets/CreateLinkAsset.vue';
import CreateNoteAsset from '@/components/ProjectAssets/CreateNoteAsset.vue';

export default {
  name: 'AddAssetsModal',

  components: {
    CreateMediaAsset,
    CreateLinkAsset,
    CreateNoteAsset,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    onAssetCreated: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      active: false,
      current: 'CreateMediaAsset',
    };
  },

  methods: {
    handleActive(active) {
      this.active = active;
    },
    // eslint-disable-next-line no-unused-vars
    async handleAssetCreated(assetId) {
      // try {
      //   const { projectAssetId } = await this.$store.dispatch({
      //     type: 'ui/projectAssets/store',
      //     id: this.projectId,
      //     body: {
      //       assetId,
      //     },
      //   });
      //   if (typeof this.onAssetCreated === 'function') {
      //     this.onAssetCreated(projectAssetId);
      //   }
      // } catch (error) {
      //   //
      // }
    },
  },
};
</script>
